// uniswap pools
export const uniswapPoolArbUsdcArbitrum = {
  address: "0xcDa53B1F66614552F834cEeF361A8D12a0B8DaD8",
};
export const uniswapPoolWethUsdcArbitrum = {
  address: "0xC31E54c7a869B9FcBEcc14363CF510d1c41fa443",
};
export const uniswapPoolGmxUsdcArbitrum = {
  address: "0x1aEEdD3727A6431b8F070C0aFaA81Cc74f273882",
};
export const uniswapPoolWbtcWethArbitrum = {
  address: "0x2f5e87C9312fa29aed5c179E456625D79015299c",
};
export const uniswapPoolArbUsdcNativeArbitrum = {
  address: "0xb0f6cA40411360c03d41C5fFc5F179b8403CdcF8",
};
export const uniswapPoolWethUsdcNativeArbitrum = {
  address: "0xC6962004f452bE9203591991D15f6b388e09E8D0",
};

// marginly pools
export const marginlyPoolArbUsdcArbitrum = {
  address: "0x5ceB22fe09C7259b9dceef243615f180664BCE70",
};
export const marginlyPoolWethUsdcArbitrum = {
  address: "0x53C08A5e2b7bc973d3d5Aee60373969E30e93B93",
};
export const marginlyPoolWbtcWethArbitrum = {
  address: "0x99Cc2A68e121F2434db5C5D63670212F07f89ee8",
};
export const marginlyPoolWethUsdcNativeArbitrum = {
  address: "0x87e711BcB9Ed1f2f6dec8fcC74cD2e0613D43b86",
};
export const marginlyPoolArbUsdcNativeArbitrum = {
  address: "0x0F750fBb044037254b5843C6b4a715AA12876d94",
};
